module.exports = __webpack_public_path__ + "static/media/trash.32620a66.svg";